import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import CustomizeAppearance from '../../components/company/customize-appearance';

function CompanyAppearance({ company }) {
    const { partnerStore, store, brandingStore } = useStores();

    const saveColor = async (primaryColor, secondaryColor) => {
        await partnerStore.update(company.company_id, {
            'ui.colors.primary': primaryColor,
            'ui.colors.secondary': secondaryColor,
        });

        if (partnerStore.editingCompany.company_id === store.companyId) {
            if (!store.currentCompany.settings) {
                store.currentCompany.settings = {};
            }
            
            Object.keys(store.currentCompany.settings).forEach(key => {
                if (key.startsWith('ui.')) {
                    delete store.currentCompany.settings[key];
                }
            });
            
            Object.assign(store.currentCompany.settings, partnerStore.editingCompany.uiSettings);
            brandingStore.updateBranding(partnerStore.editingCompany.uiSettings);
        }
    };

    const savePlayerCustomization = async ({
        fontFamily,
        fontUrl,
        hideClose,
        customCss,
    }) => {
        await partnerStore.update(company.company_id, {
            'ui.font.family': fontFamily || null,
            'ui.font.url': fontUrl || null,
            'ui.player.hideClose': hideClose ? '1' : '0',
            'ui.my.customCss': customCss || null,
        });

        if (partnerStore.editingCompany.company_id === store.companyId) {
            if (!store.currentCompany.settings) {
                store.currentCompany.settings = {};
            }
            Object.assign(store.currentCompany.settings, {
                'ui.font.family': fontFamily || '',
                'ui.font.url': fontUrl || '',
                'ui.player.hideClose': hideClose ? '1' : '0',
                'ui.my.customCss': customCss || '',
            });
            brandingStore.updateBranding(partnerStore.editingCompany.uiSettings);
        }
    };

    const resetToDefaults = async () => {
        let result = await partnerStore.update(company.company_id, {
            'ui.colors.primary': null,
            'ui.colors.secondary': null,
            'ui.font.family': null,
            'ui.font.url': null,
            'ui.player.hideClose': null,
            'ui.my.customCss': null,
            logoName: null,
        });
        
        if (partnerStore.editingCompany.company_id === store.companyId) {
            if (!store.currentCompany.settings) {
                store.currentCompany.settings = {};
            }
            
            Object.keys(store.currentCompany.settings).forEach(key => {
                if (key.startsWith('ui.')) {
                    delete store.currentCompany.settings[key];
                }
            });
            
            Object.assign(store.currentCompany.settings, partnerStore.editingCompany.uiSettings);
            brandingStore.updateBranding(partnerStore.editingCompany.uiSettings);
        }
        
        return result;
    };

    const importLogo = async (formData) => {
        await partnerStore.uploadLogoAsPartnerAdmin(
            company.company_id,
            formData
        );
    };

    const removeLogo = async () => {
        await partnerStore.removeLogoAsPartnerAdmin(company.company_id);
    };

    return (
        <CustomizeAppearance
            company={company}
            saveColor={saveColor}
            savePlayerCustomization={savePlayerCustomization}
            resetToDefaults={resetToDefaults}
            importLogo={importLogo}
            removeLogo={removeLogo}
            uploadingLogo={partnerStore.uploadingLogoAsPartner}
            saving={partnerStore.savingCompany}
        />
    );
}

export default observer(CompanyAppearance);
